import { ColumnInfo, ColumnInfoList, DisplaySetting } from 'components/shared/display_setting'
import { TableCell } from 'components/shared/widget'
import { Discount, DISCOUNT_KIND_SELECT_ITEMS } from 'entities/discount'
import { ReactNode, useMemo } from 'react'
import { Form } from 'utils/hooks'

export const discountColumnInfoList = (form?: Form<Record<string, unknown>>): ColumnInfoList => {
    return {
        tableName: '',
        values: [
            { name: 'ID', th: true, width: 50, form: form, orderAttr: 'discount_id', searchType: { name: 'id', type: 'multiple_text' } },
            { name: '名前', th: true, minWidth: 200, form: form, orderAttr: 'discount_name', searchType: { name: 'name', type: 'multiple_text' } },
            {
                name: 'タイプ',
                th: true,
                width: 120,
                form: form,
                orderAttr: 'discount_kind',
                searchType: { name: 'kind', type: 'multiple_select', selectItems: DISCOUNT_KIND_SELECT_ITEMS },
            },
            { name: '割引率', th: true, width: 120, align: 'right', form: form, orderAttr: 'discount_ratio', searchType: { name: 'ratio', type: 'number' } },
            { name: '割引額', th: true, width: 120, align: 'right', form: form, orderAttr: 'discount_value', searchType: { name: 'value', type: 'number' } },
            { name: '数量', th: true, width: 120, align: 'right', form: form, orderAttr: 'discount_amount', searchType: { name: 'amount', type: 'number' } },
            {
                name: '期間(月)',
                th: true,
                width: 120,
                align: 'right',
                form: form,
                orderAttr: 'discount_month_period',
                searchType: { name: 'month_period', type: 'number' },
            },
        ],
    }
}

export type DiscountTableDataProps = {
    discount?: Discount
    displaySetting: DisplaySetting
}

export const DiscountTableData = ({ discount, displaySetting }: DiscountTableDataProps): JSX.Element => {
    if (!discount) {
        return (
            <>
                {displaySetting.columnInfoList.values.map((_: ColumnInfo, index: number) => {
                    if (displaySetting.hiddenList.includes(index)) {
                        return <></>
                    } else {
                        return <TableCell key={index}></TableCell>
                    }
                })}
            </>
        )
    }

    const createCells = useMemo(() => {
        return (
            <>
                <TableCell>{discount.id}</TableCell>
                <TableCell>{discount.name}</TableCell>
                <TableCell>{DISCOUNT_KIND_SELECT_ITEMS.find((i) => i.value === discount.kind)?.label}</TableCell>
                <TableCell align="right" unit="%">
                    {discount.ratio ? Math.round(discount.ratio * 100) : undefined}
                </TableCell>
                <TableCell align="right" unit="円">
                    {discount.value ? discount.value.toLocaleString() : undefined}
                </TableCell>
                <TableCell align="right">{discount.amount}</TableCell>
                <TableCell align="right" unit="ヶ月">
                    {discount.monthPeriod}
                </TableCell>
            </>
        )
    }, [displaySetting.hiddenList])

    return createCells.props.children.filter((_: ReactNode, index: number) => !displaySetting.hiddenList?.includes(index)).map((cell: ReactNode) => cell)
}
